import { Component, Input, OnInit } from '@angular/core';
import { features, routes } from '@app/consts';
import { modules } from '@app/consts/modules';
import { CurrentUserDetails } from '@app/shared/models/employee.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EmployeeService } from '@app/core/services/employee.service';
import { TranslationService } from '@app/core/services/translation.service';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss']
})
export class NavigationMenuComponent implements OnInit {
  public routes: typeof routes = routes;
  public modules: typeof modules = modules;
  public features: typeof features = features;
  public isOpenUiElements = false;
  @Input() showTooltip: boolean;

  siteSettingsFeatures = [
    features.SITE_SETTINGS,
    features.ORGANIZATION,
    features.POSITIONS,
    features.COST_CENTERS,
    features.LISTS,
    features.WORK_LOCATIONS,
    features.WORK_ROTATIONS,
    features.TIME_OFF,
    features.FORMS,
    features.CURRENCY,
    features.GLOBALIZATION,
    features.SCHEDULES,
    features.COUNTRY_CONFIG,
    features.BUSINESS_RULE_AUTOMATION,
  ]
  currentEmployeeDetails: CurrentUserDetails;

  menuItems = [];

  translationsLoaded: boolean = false;

  constructor(
    public translate: TranslateService,
    private employeeService: EmployeeService,
    private translationService: TranslationService,
  ) {
    this.currentEmployeeDetails = this.employeeService.getFetchedCurrentUserDetails()
  }

  ngOnInit(): void {
    // If translations are already loaded set the columns
    if (this.translationService.currentTranslations !== null) {
      this.translationsLoaded = true;
      this.setColumnsWithTranslations();
    }

    // once the translations for the app have loaded set the columns to the correct translation values
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translationsLoaded = true;
      this.setColumnsWithTranslations();
    });
  }

  setColumnsWithTranslations() {
    this.menuItems = [
      {
        route: routes.HOMEPAGE,
        feature: features.HOMEPAGE,
        module: 'allow',
        icon: 'home',
        localizationCode: 'Homepage'
      },
      {
        route: routes.DASHBOARD,
        feature: features.DASHBOARDS,
        module: 'allow',
        icon: 'dashboard',
        localizationCode: 'Dashboard'
      },
      {
        route: routes.TALENT_TRACK,
        feature: features.TALENT,
        module: 'allow',
        icon: 'group',
        localizationCode: 'Talent'
      },
      {
        route: routes.REPORTS,
        feature: features.REPORTS,
        module: 'allow',
        icon: 'assessment',
        localizationCode: 'Reports'
      },
      {
        route: routes.SITE_SETTINGS,
        feature: this.siteSettingsFeatures,
        module: 'allow',
        icon: 'settings_applications',
        localizationCode: 'SiteSettings'
      },
      {
        route: routes.TIME_OFF,
        feature: features.TIME_OFF_MENU,
        module: 'allow',
        icon: 'access_time',
        localizationCode: 'TimeOff'
      },
      {
        route: `${routes.SECURITY}${routes.ROLES}`,
        feature: features.SECURITY,
        module: 'allow',
        icon: 'security',
        localizationCode: 'Security'
      },
      {
        route: `${routes.PERFORMANCE}`,
        feature: features.PERFORMANCE,
        module: modules.PERFORMANCE,
        icon: 'speed',
        localizationCode: 'Performance'
      },
      {
        route: `${routes.DOCUMENTS}`,
        feature: [features.DOCUMENTS_LIBRARY, features.DOCUMENTS_ACCESS],
        module: modules.DOCUMENTS_LIBRARY,
        icon: 'folder',
        localizationCode: 'Documents'
      },
      {
        route: `/${routes.LETTERS}`,
        feature: [features.LETTERS_ADMINISTRATION, features.LETTERS_PUBLISHER],
        module: modules.LETTERS,
        icon: 'email',
        localizationCode: 'Letters'
      },
      {
        route: `/${routes.IMPORTS}`,
        feature: features.IMPORTS,
        module: 'allow',
        icon: 'file_upload',
        localizationCode: 'Imports'
      },
      {
        route: '/Assistant',
        feature: 'allow',
        module: 'allow',
        icon: 'auto_awesome',
        localizationCode: 'Assistant'
      },
    ]

    if (this.currentEmployeeDetails.userType === 'User') {
      this.menuItems.push(
        {
          route: `${routes.ADMIN_CONTROLS}${routes.POSITIONS}`,
          feature: 'allow',
          module: 'allow',
          icon: 'admin_panel_settings',
          localizationCode: 'AdminControls'
        }
      )
    }
  }

  public openUiElements() {
    this.isOpenUiElements = !this.isOpenUiElements;
  }

}
